import { CDN_DOMAIN, NEW_CDN_DOMAIN } from '../constants';

// 非开发环境，配置crossorigin
const corsEnable = process.env.ZONE_ENV ? { crossorigin: '' } : {};

/**
 * 非开发环境并且链接包含CDN_DOMAIN，配置crossorigin
 * @param src
 * @returns {{crossorigin: string}}
 */
function corsEnableForCDN(src) {
  let crossoriginRes = {};
  if (process.env.ZONE_ENV) {
    if (src.includes(CDN_DOMAIN)) {
      crossoriginRes = { crossorigin: '' };
    }
    if (src.includes(NEW_CDN_DOMAIN)) {
      crossoriginRes = { crossorigin: '' };
    }
  }
  return crossoriginRes;
}

// 冒泡排序
function bubble(arr, str) {
  for (let i = 0; i < arr.length - 1; i++) {
    for (let j = 0; j < arr.length - 1 - i; j++) {
      const isUP = new Date(arr[j][str]) < new Date(arr[j + 1][str]);
      if (isUP) {
        const tempItem = arr[j];
        arr[j] = arr[j + 1];
        arr[j + 1] = tempItem;
      }
    }
  }
  return arr;
}

export { bubble, corsEnable, corsEnableForCDN };
